import { Link, useLocation } from 'react-router-dom';
import React, { useCallback } from 'react';
import { ReactComponent as HeaderIcon } from '../../../assets/icons/svg/icon-new-lili-logo.svg';
import { ReactComponent as ActiveLinkIndicator } from '../../../assets/icons/svg/menu-icons/ic-menu-active-link.svg';
import Heading from '../../../generic-components/Heading';
import { useStore } from '../../../store';

interface INavigateLink {
  title: string;
  hrefValue: string;
  flowPosition: number;
}

const linksList: INavigateLink[] = [
  {
    title: 'Personal Details',
    hrefValue: '/accountant-onboarding/personal-details',
    flowPosition: 1,
  },
  {
    title: 'Verify Phone',
    hrefValue: '/accountant-onboarding/verify-phone',
    flowPosition: 2,
  },
  {
    title: 'Create Password',
    hrefValue: '/accountant-onboarding/create-password',
    flowPosition: 3,
  },
];

export const SideNavigator = () => {
  const location = useLocation();
  const obData = useStore((state) => state.obData);
  const isLinkActive = useCallback((href: string) => location.pathname.includes(href), [location]);
  const handleClick = (e: any, selectedFlowPos: number) => {
    if (obData.lastStepVisit <= selectedFlowPos) {
      e.preventDefault();
    }
  };
  return (
    <div className='gap-[8px] flex flex-col justify-center basis-[360px] h-full bg-bw00 border-r border-bw03 px-[100px]'>
      <HeaderIcon className='w-[76px]' />
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      {linksList.map((l) => (
        <Link className='flex items-center gap-[8px]' to={l.hrefValue} onClick={(e) => handleClick(e, l.flowPosition)}>
          {isLinkActive(l.hrefValue) && <ActiveLinkIndicator />}
          <Heading
            title={l.title}
            className={`font-metricRMedium text-[16px] ${isLinkActive(l.hrefValue) ? 'text-action03' : 'text-bw05'}`}
          />
        </Link>
      ))}
    </div>
  );
};
